import { render, staticRenderFns } from "./DefaultConfig.vue?vue&type=template&id=990ec41e&scoped=true&"
import script from "./DefaultConfig.vue?vue&type=script&lang=js&"
export * from "./DefaultConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990ec41e",
  null
  
)

export default component.exports